// @flow
export default (a: string = '', b: string = '', desc: boolean = false) =>
  desc ? a.localeCompare(b) : b.localeCompare(a)
